// @ts-check

/** @file Defines the local BoardColumn shell and associations. */

import BoardColumnBase from "../model-bases/board-column.js"
import {PROJECT_REPLICA_DATABASE_IDENTIFIER, projectReplicaModel} from "../database/project-replica-contract.js"
import {PROJECT_REPLICA_SYNC_DECLARATION} from "../database/project-replica-sync.js"

/** Board-column row in the local application replica. */
const BoardColumnModel = projectReplicaModel(BoardColumnBase)

export default BoardColumnModel

BoardColumnModel.setDatabaseIdentifier(PROJECT_REPLICA_DATABASE_IDENTIFIER)
BoardColumnModel.switchesTenantDatabase(PROJECT_REPLICA_DATABASE_IDENTIFIER)
BoardColumnModel.sync = PROJECT_REPLICA_SYNC_DECLARATION
BoardColumnModel.belongsTo("board")
BoardColumnModel.hasMany("taskBoards")
